
<div class="row justify-content-center">

  <div class="col-lg-8 content-area">
    <div class="page-card">
      <div id="charities">
        <h2 class="f-s-20 f-w-700 m-t-24">
          Charities
        </h2>
      </div>
      <div id="createcharity">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'createcharity'">
          Create Charity
        </h2>

        <p class="f-s-14">
          If this is your first time logging in to the software, the following screen will be displayed.
        </p>

        <img class="doc-screenshot" src="../../../../assets/images/logos/welcomecharity.jpg" />

        <p class="f-s-14">
          Click on <img src="../../../../assets/images/logos/buttoncharity.jpg" /> to create first charity.
        </p>

        <p class="f-s-14">
          There are 5 sections to enter the charity details:
        </p>

        <ol class="sub-feature-list">
          <li>Charity Type</li>
          <li>Charity Details</li>
          <li>Trustees Details</li>
          <li>Professional Advisor Details</li>
          <li>Financial Setup</li>
        </ol>

        <img class="doc-screenshot" src="../../../../assets/images/logos/ACharitynewone.jpg">

        <p class="f-s-14">
          Next, select the Charity Jurisdiction & Type. The selected charity type determines the information that
          must be entered throughout the setup process.
        </p>
        <ol class="sub-feature-list1">
          <li>Charitable Incorporate Organisation (CIO)</li>
          <li>Charitable Company (Incorporated)</li>
          <li>Unincorporated Charity</li>
        </ol>

        <p class="f-s-14">
          Choose from the mentioned options &amp; click on  <img src="../../../../assets/images/logos/next button.jpg" />
        </p>
        <img class="doc-screenshot" src="../../../../assets/images/logos/addcharity.png" />
        <p class="f-s-14">
          Complete all the charity details, ensuring that all <span style="color:red">*</span>mandatory fields are filled in.
        </p>

        <ul class="f-s-14">
          <li>
            <strong>Charity Name</strong>: Enter the name of the charity. This name will be displayed on reports and submissions
          </li>
        </ul>
      </div>

      <div id="searchcharity">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'searchcharity'">
          Search Charity
        </h2>

        <p class="f-s-14">
          If the charity is already registered with the Charity Commission, click the Search button <img src="../../../../assets/images/logos/searchcharity.png" /> and search for the charity using its name or registration number.
        </p>

        <img src="../../../../assets/images/logos/seachcommission.png" />

        <p class="f-s-14">
          After selecting the charity from the Search Charity Commission window, the charity details will be automatically populated, provided the information is available with the Charity Commission.
        </p>

        <ul class="f-s-14">
          <li><strong>Jurisdiction</strong>: England and Wales | Scotland will be fetched based on the selection.</li>
          <li><strong>Company Reference Number</strong>: Enter the Company Registration Number. The number must contain 8 characters.</li>
          <li><strong>Charity Registration Number</strong>: Enter the Charity Registration Number. The number must contain 8 characters.</li>
          <li><strong>Date of Registration</strong>: The date on which the charity was officially registered.</li>
        </ul>

        <p class="f-s-14">
          You can also fill the Registration &amp; Address Details.
        </p>

        <p class="f-s-14">
          The trading status option will not be available, if charity type is <strong>‘Unincorporated Charity’</strong>
        </p>

        <img src="../../../../assets/images/logos/trading.jpg" />

        <p class="f-s-14">
          If you select <strong>‘Yes’</strong> for <strong>‘Do you want to add a separate contact detail for this Charity?’</strong> option,
        </p>

        <img src="../../../../assets/images/logos/Contactdetails.png" />

        <p class="f-s-14">
          complete all the contact details, ensuring that all *mandatory fields are filled in.
        </p>
        <p class="f-s-14">

          Once completed, click on <img src="../../../../assets/images/logos/next button.jpg" /> continue.
        </p>

        <p class="f-s-14">
          To add trustee details, click the <img src="../../../../assets/images/logos/addtrustee.png" /> button.
        </p>

        <img src="../../../../assets/images/logos/addnewtrustee.png" />

        <p class="f-s-14">
          Enter the trustee's name and the date of appointment.
        </p>

        <p class="f-s-14">
          If the trustee is the Chair of the Board, select the  <img src="../../../../assets/images/logos/chair or the borad.png" /> option. Then complete the remaining details, including the Charity Name, Charity Number, and Reporting Status.
        </p>

        <img src="../../../../assets/images/logos/charityname.png" />

        <p class="f-s-14 d-flex align-items-center gap-2">



          Click <img src="../../../../assets/images/logos/save.png" /> to save the trustee details & click on <img src="../../../../assets/images/logos/next button.jpg" alt="Save" style="height:32px;">
        </p>

        <p class="f-s-14">
          If you do not wish to enter the trustee details at this stage, click <img src="../../../../assets/images/logos/skip.png" /> to continue..
        </p>

        <p class="f-s-14">
          Next, enter the Professional Adviser details.
        </p>

        <img src="../../../../assets/images/logos/professionaladvisor.jpg" />
        <img src="../../../../assets/images/logos/independentexaminardetails.jpg" />

        <p class="f-s-14">
          Enter the details of the Professional Adviser(s), including the Accountant, Banker, Solicitor, Independent Examiner, and Auditor, as applicable.
        </p>

        <p class="f-s-14">
          Complete the name and address details for each adviser. Once all the required information has been entered, click on <img src="../../../../assets/images/logos/next button.jpg" /> to continue.
        </p>

        <p class="f-s-14">
          In the Financial Setup section, select the appropriate accounting period for the charity.
        </p>

        <img style="height: 350px !important;" src="../../../../assets/images/logos/fiveoptionscharity.jpg" />

        <p class="f-s-14">
          If this is not the first accounting period, select ‘No’ for the ‘Is this the first accounting period?’ option.
        </p>

        <p class="f-s-14">
          Then enter the mandatory ‘Last Accounting Period Start Date’ and ‘Last Accounting Period End Date’ fields.
        </p>

        <p class="f-s-14">
          If this is the charity's first accounting period, select Yes for the ‘Is this the first accounting period?’ option.
        </p>

        <p class="f-s-14">
          Then enter the ‘Current Accounting Period’ details by selecting the ‘Start Date’ and ‘End Date’.
        </p>

        <p class="f-s-14">
          For,
        </p>

        <ol class="sub-feature-list">
          <li>Charitable Incorporate Organisation (CIO) – Its minimum of 6 months and maximum of 18 months.</li>
          <li>Charitable Company (Incorporated)- Its minimum of 1 day.</li>
          <li>Unincorporated Charity- Its minimum of 6 months and maximum of 18 months.</li>
        </ol>

        <p class="f-s-14">
          After selecting the Current Accounting Period, choose the appropriate accounting method.
        </p>

        <p class="f-s-14">
          Select the appropriate accounting method based on the charity's reporting requirements. You can choose either Accruals (FRS 102 SORP) or Cash (Receipts &amp; Payments).
        </p>
        <img src="../../../../assets/images/logos/accountingmethod.png" />
        <p class="f-s-14">
          If you select Accruals (FRS 102 SORP) as the Accounting Method, select the appropriate Accounting Template from the following options:
        </p>

        <ol class="sub-feature-list">
          <li>Micro Charity</li>
          <li>Small Charity (< £500,000) </li>
          <li>Medium Charity (£500,000 – £15 Million) </li>
          <li>Large Charity (> £15 Million)  </li>
        </ol>

        <img style="height:300px" src="../../../../assets/images/logos/microocharity.jpg" />
        <p class="f-s-14">Select the template that applies to the charity based on its requirements.</p>
        <p class="f-s-14">
          The trading status option will not be available, if charity type is : <strong>‘Unincorporated Charity’</strong>.
        </p>
        <img class="amndimg" src="../../../../assets/images/logos/istradingimage.jpg" />
        <p class="f-s-14">
          For the <strong>Scotland (OSCR) jurisdiction</strong>, if the <strong>Trading Type</strong> is selected as <strong>“Yes”</strong>, a confirmation pop-up will be displayed indicating that the charity is being prepared as <strong>Dormant</strong>.
        </p>
        <img class="amndimg" src="../../../../assets/images/logos/Domatyes.jpg" />
        <p class="f-s-14">
          After selecting the accounting method & trading status, choose the appropriate report type:
        </p>
        <p class="f-s-14">
          Independent Examiner or Auditor or None.
        </p>
        <img class="amndimg" src="../../../../assets/images/logos/independentnone.jpg" />

        <p class="f-s-14">
          Also select the Account type: Original or Amended
        </p>
        <img class="amndimg" src="../../../../assets/images/logos/amendchart.png" />

        <p class="f-s-14">
          The Report Title is automatically populated based on the selected Report Type and Account Type.
        </p>
        <img src="../../../../assets/images/logos/charitytable.png" />

        <p class="f-s-14">
          Enable Fund Tracking to manage Restricted, Unrestricted, and Endowment funds within the charity's accounts.
        </p>

        <img src="../../../../assets/images/logos/enablefundtracking.png" />

        <p class="f-s-14">
          Note: For the Cash (Receipts &amp; Payments) accounting method, Fund Tracking is enabled by default and cannot be disabled.
        </p>

        <p class="f-s-14">
          After setting up all the details you can click on
        </p>

        <img style="height:43px" src="../../../../assets/images/logos/finishingup (2).jpg" />

        <p class="f-s-14">
          After completing the setup, click Finish to save the charity details. The charity will be created successfully, and you will have the option to start the accounting period.
        </p>
        <img style="height:133px" src="../../../../assets/images/logos/charitycreation.png" />
      </div>

      <div id="view-charity">
        <h2 class="f-s-20 f-w-700 m-t-24" [class.active-heading]="selectedSection === 'view-charity'">View Charity</h2>

        <p class="f-s-14">
          To view all the charities, you have created, click Charities in the top-left corner of the screen. The Charities page displays a list of all created charities.
        </p>

        <p class="f-s-14">
          To view a charity's details, click the Charity Name under the Charity Details section. The Charity Overview page is then displayed, providing an overview of the selected charity.
        </p>

        <p class="f-s-14">
          After selecting the Charity, you will have a Charity Overview.
        </p>
      </div>

      <div id="charity-overview">
        <h2 class="f-s-20 f-w-700 m-t-24" [class.active-heading]="selectedSection === 'charity-overview'">Charity Overview</h2>

        <p class="f-s-14">
          The Edit and Delete options are available in the top-right corner of the Charity Overview page.
        </p>

        <p class="f-s-14">
          To edit charity details, click on <img src="../../../../assets/images/logos/editdetails.png" /> button.
        </p>

        <p class="f-s-14">
          To delete a charity, click the <img src="../../../../assets/images/logos/click.png" /> button and select <img src="../../../../assets/images/logos/deletecharity.png" />
        </p>

        <p class="f-s-14">
          To add a new accounting period, select the Financials tab and click Add Accounting Period.
        </p>
        <img class="doc-screenshot" src="../../../../assets/images/logos/financialperiods.png" />
        <img class="doc-screenshot" src="../../../../assets/images/logos/financial.png" />
        <img class="doc-screenshot" src="../../../../assets/images/logos/professionaladvisors.jpg" />
        <p class="f-s-14">
          The Trustees tab allows you to Add, Retrieve, and Search trustee records.
        </p>

        <p class="f-s-14">
          The Professional Adviser tab allows you to add Professional Adviser details.
        </p>
      </div>

      <div id="edit-charity">
        <h2 class="f-s-20 f-w-700 m-t-24" [class.active-heading]="selectedSection === 'edit-charity'">Edit Charity</h2>

        <p class="f-s-14">
          To edit a charity, click the <img src="../../../../assets/images/logos/edit.png" /> option under the ‘Action’ column.
        </p>

        <p class="f-s-14">
          Make the required changes, then click on to <img src="../../../../assets/images/logos/update.jpg" /> save the updated details.
        </p>
      </div>


      <div id="delete-charity">
        <h2 class="f-s-20 f-w-700 m-t-24" [class.active-heading]="selectedSection === 'delete-charity'">Delete Charity</h2>

        <p class="f-s-14">
          To delete any charity, click on <img src="../../../../assets/images/logos/delete.png" /> option under ‘Action’ and you can delete the selected charity.
        </p>

        <p class="f-s-14">
          If anyone of the Accounting Period is Finalised for the selected charity, then the Charity cannot be deleted. You can delete a charity only if the Accounting Period is not finalised yet.
        </p>
      </div>


      <div id="search-charity-lists">
        <h2 class="f-s-20 f-w-700 m-t-24" [class.active-heading]="selectedSection === 'search-charity-lists'">Search Charity</h2>
        <p class="f-s-14">
          Use the Search box in the top-left corner of the page to search for charities.
        </p>
        <img style="width: 668px !important;"  class="doc-screenshot" src="../../../../assets/images/logos/searchcharity1.png" />
      </div>


      <div id="filter">
        <h2 class="f-s-20 f-w-700 m-t-24" [class.active-heading]="selectedSection === 'filter'">
          Filter
        </h2>
        <p class="f-s-14">
          Use the  <img class="doc-screenshot" src="../../../../assets/images/logos/filtericonsmall.jpg" /> option to filter the list of charities by Type, Jurisdiction, or Status.
        </p>
        <img class="doc-screenshot" src="../../../../assets/images/logos/charity_junctions.png" />
      </div>

    </div>
  </div>
  <div class="col-lg-3">
    <div class="on-page-sidebar">

      <p class="sidebar-title">On this page</p>


          <ul *ngIf="charitiesExpanded"
              class="submenu-right scroll-container">

            <li [class.activeSub]="[
      'createcharity',
      'searchcharity'
    ].includes(selectedSection)">

              <div class="submenu-parent"
                   (click)="toggleCreateCharityMenu()">

                Create Charity

              </div>

              <ul 
                  class="submenu-level-2">

                <li [class.active]="selectedSection === 'searchcharity'"
                    (click)="changeSection('searchcharity')">

                  Search Charity

                </li>

              </ul>

            </li>

            <!--<li class="charities-parent-active"
                [class.charities-parent-active]="['createcharity','searchcharity','view-charity','charity-overview','edit-charity','delete-charity','search-charity-lists','filter'].includes(selectedSection)" [class.active]="selectedSection === 'createcharity'"
                (click)="changeSection('createcharity')">

              Create Charity

            </li>-->

            <li [class.active]="selectedSection === 'view-charity'"
                (click)="changeSection('view-charity')">

              View Charity

            </li>

            <li [class.active]="selectedSection === 'charity-overview'"
                (click)="changeSection('charity-overview')">

              Charity Overview

            </li>

            <li [class.active]="selectedSection === 'edit-charity'"
                (click)="changeSection('edit-charity')">

              Edit Charity

            </li>

            <li [class.active]="selectedSection === 'delete-charity'"
                (click)="changeSection('delete-charity')">

              Delete Charity

            </li>

            <li [class.active]="selectedSection === 'search-charity-lists'"
                (click)="changeSection('search-charity-lists')">

              Search Charity

            </li>

            <li [class.active]="selectedSection === 'filter'"
                (click)="changeSection('filter')">

              Filter

            </li>

          </ul>


    </div>
  </div>

</div>
